<script setup lang="ts">
  import IconButton from "@/components/ui/icon-button/IconButton.vue"

  const { title, hasBackButton } = defineProps<{
    title: string
    hasBackButton?: boolean
  }>()

  const emits = defineEmits(["back"])

  const onBackClick = () => {
    emits("back")
  }
</script>

<template>
  <div class="flex items-baseline gap-2 sm:gap-3">
    <IconButton
      v-if="hasBackButton"
      :icon="'ArrowLeft'"
      :size="'responsive'"
      :disabled="false"
      :label="'Go back'"
      data-testid="page-header-back-button"
      aria-label="Go back"
      @click="onBackClick"
    ></IconButton>
    <h1 class="text-secondary-700 dark:text-secondary-100">{{ title }}</h1>
  </div>
</template>
